<template>
  <div class=" maincontent">
    <loading :active.sync="isLoading"
            :can-cancel="true"
            color="#5bad2b"
            :is-full-page="fullPage"></loading>
    <div class="box-header">
      <h3 class="box-title pageTitle fw-600">Select Interviwers</h3>
      <a style="float:right" class="backicon" @click="goBack()"><i
        class="fa fa-arrow-left "
        aria-hidden="true"
      ></i> Back</a>
    </div>
    <hr style="margin-top:2px; margin-bottom:6px" />
    <div class="mycontent">
      <div class="row postDetail" @click="goBack()" v-if="postData != null">
        <div class="col-md-5 p-1">
          <div class="candidateArea">
            <div class="Orgimage1">
              <img
                class="round"
                v-if="postData.org_logo !='' && postData.org_logo !=null"
                :src="`${postData.org_logo}`"
              />
              <img
                class="round"
                v-if="postData.org_logo =='' || postData.org_logo ==null"
                src="../assets/img/default.png"
              />
            </div>
            <div class="candidateDetails col-md-12">
              <span class="canName">{{postData.job_tittle}}</span>
              <br />
              <span>{{postData.post_unique_id}}</span>
              <br />
              <!-- <span>9677696198</span> -->
              <span class="overflow" :title="postData.primaryskillnames">
                <span class="skill-lable">Skills :</span>
                {{postData.primaryskillnames}}
              </span>
            </div>
            <!-- <div class="col-md-11 p-1">
                              <div class="mt-2"></div>
            </div>-->
          </div>
        </div>
        <div class="col-md-7 p-1">
          <div class="row">
            <div class="col-md-3 p-1 countcard" style="text-align:center">
              <a>
                <div class="countStyle">{{postData.profile_count}}</div>
                <div class="countSpecificationStyle">Profiles</div>
              </a>
            </div>
            <div class="col-md-3 p-1" style="text-align:center">
              <a>
                <div class="countStyle">{{postData.scheduled_count}}</div>
                <div class="countSpecificationStyle">Scheduled</div>
              </a>
            </div>
            <div class="col-md-3 p-1" style="text-align:center">
              <a>
                <div class="countStyle">{{postData.sit_count}}</div>
                <div class="countSpecificationStyle">SIT>6</div>
              </a>
            </div>
            <div class="col-md-3 p-1" style="text-align:center">
              <a>
                <div class="countStyle">{{postData.selected_count}}</div>
                <div class="countSpecificationStyle">Selected</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- card comp -->
      <!-- <CardView v-if="posttabOne" @interestRequest="interestRequestEmit" :postprofile="true" :data="releventprofiles" :showRole="showRole" :selectpost="selectpost"></CardView> -->
      <div class="col-md-3 filterBoxBorder">
        <div class="box box-primary">
          <div class="box-header with-border filterbyClass">
            <h3 class="box-title">Filter By</h3>
            <div class="box-tools pull-right">
              <button type="button" @click="clearFilter" class="btn btn-box-tool btncolorClass">
                <b>Clear</b>
              </button>
            </div>
          </div>
          <div class="box-body">
            <ul class="filterTopclass">
              <li class="filterListclass">
                <div>
                  <a>Status</a>
                </div>
                <div class="filterDivclass form-group">
                  <div class="form-select">
                    <select
                      class="form-control"
                      style="height:30px"
                      placeholder="Select Status"
                      v-model="statusFilter"
                      @change="getRelaventProfiles"
                    >
                      <option value="" selected>Select Status</option>
                      <option value="all">All</option>
                      <option value="selected">Selected</option>
                      <option value="unselected">UnSelected</option>
                    </select>
                    <span class="select-icon">
                      <i class="fa fa-chevron-down"></i>
                    </span>
                  </div>
                </div>
              </li>
              <li class="filterListclass">
                <div>
                  <a>Rating</a>
                  <!-- <span class="pull-right"><i class="" v-bind:class="{ 'fa fa-angle-up' : activeFilter == 'score', 'fa fa-angle-down' : activeFilter != 'score' }"></i></span> -->
                </div>
                <div class="filterDivclass  form-group">
                  <div class="form-select">
                    <select
                      class="form-control"
                      placeholder="Select Score"
                      style="height:30px"
                      v-model="ratingFilter"
                      @change="getRelaventProfiles"
                    >
                      <option value="" selected
                        >Select Rating</option
                      >
                      <option
                        :value="n"
                        v-for="n in 5"
                        :key="n"
                        >{{ n }}</option
                      >
                    </select>
                    <span class="select-icon"
                      ><i class="fa fa-chevron-down"></i
                    ></span>
                  </div>
                </div>
              </li>
              <li class="filterListclass">
                <div>
                  <a>interviewer cost</a>
                </div>
                <div class="filterDivclass">
                  <div>
                    <p>Cost From <span class="pull-right">{{interviewerCostFrom}}</span></p>
                    <input type="range" min="0" max="10000" v-model="interviewerCostFrom" @change="getRelaventProfiles" class="slider1">
                    <br />
                    <p>Cost To <span class="pull-right">{{interviewerCostTo}}</span></p>
                    <input type="range" min="0" max="10000" v-model="interviewerCostTo"  @change="getRelaventProfiles" class="slider2">
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box-body col-md-9">
        <div class="row">
          <div class="filterdata">
            <div class="searchinput">
              <input
                v-model="postSearch"
                type="text"
                class=" search-text"
                placeholder="Search.."
              />
              <!-- @keyup="getRelaventProfiles" -->
              <button @click="getRelaventProfiles"><i class="fa fa-search" ></i></button>
              &nbsp;&nbsp; <button v-if="postSearch.length > 0" @click="postSearch =''; getRelaventProfiles()">Clear</button>
            </div>
            <button @click="selectInterviewers()" class="btn btn-success">Done</button>
          </div>
          <!-- <div class="pull-right">
            <button @click="selectInterviewers()" class="btn-success roundedBorder">Done</button>
          </div> -->
        </div>
        <ul class="products-list product-list-in-box  postArea">
          <li class="postAreaLi" v-for="(x, index) in releventprofilesList" :key="index">
            <div class="row">
              <div class="ratingArea">
                <div class="col-md-5 canImage">
                  <div class="Orgimage">
                    <img
                      @click="showModal(x._id)"
                      v-if="x.profile_picture !='' && x.profile_picture !=null"
                      :src="`${x.profile_picture}`"
                      class="round"
                    />
                    <img
                      @click="showModal(x._id)"
                      v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null"
                      src="../assets/img/default.png"
                      class="round"
                    />
                    <img
                      @click="showModal(x._id)"
                      v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'"
                      src="../assets/img/female_default.png"
                      class="round"
                    />
                    <img
                      @click="showModal(x._id)"
                      v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'"
                      src="../assets/img/male_default.png"
                      class="round"
                    />
                    <!-- <img class="round" v-if="post.profile_picture !='' && post.profile_picture !=null" :src="`${post.profile_picture}`" alt=""> -->
                  </div>
                  <!-- </div> -->
                  <!-- <CardView v-if="posttabOne" @interestRequest="interestRequestEmit" :postprofile="true" :data="releventprofiles" :showRole="showRole" :selectpost="selectpost"></CardView> -->
                  <div @click="showModal(x._id)">
                    <a
                      href="javascript:void(0)"
                      class="product-title name"
                    >{{x.first_name}} {{x.last_name}}</a>
                    <span class="product-description">
                      <span :title="x.designation" class="skill-lable">Designation :</span>
                      {{x.designation}}
                    </span>
                  </div>
                </div>
                <div class="col-md-4">
                  <button class="btn btn-default btn-xs btns pull-left ml8">
                    <i class="uil uil-rupee-sign"></i>
                    {{costReferTag == 'special' ? x.original_interview_cost : x.interview_cost}} / Interview
                  </button>
                </div>
                <div class="col starRatings">
                  <!-- <li class="list-group-item"> -->
                  <label for="Rating" style="color:gray; padding-top:6px">Rating</label>
                  <p class="text-muted text-center rating">
                    <star-rating
                      class="pull-right star starRating"
                      style="width:100%"
                      :show-rating="false"
                      active-color="#5bad2b"
                      v-bind:increment="1"
                      v-bind:star-size="25"
                      :rating="Number(x.interviewer_rating)"
                      read-only
                    ></star-rating>
                  </p>
                </div>
              </div>
            </div>
            <div class="row selectArea">
              <div class="col-md-6">
                <span class="product-description ml-5">
                  <span class="skill-lable" :title="x.userskillnames">Skillset :</span>
                  {{x.userskillnames}}
                </span>
              </div>
              <div class="col-md-6">
                <button
                  @click="selectone(x)"
                  v-bind:class="{ 'fa fa-check-circle fa-2x isSelected pull-right' : x.selected_interviewer=='Yes', 'btn btn-success btn-sm pull-right' : x.selected_interviewer!='Yes' }"
                >{{x.selected_interviewer=='Yes' ? '':'Select'}}</button>
              </div>
              <div></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <profile-modal v-model="modalOpen" :shwovalueProfileProfile="modalOpen" v-if="modalOpen"></profile-modal>
  </div>
</template>

<script>
import Vue from 'vue'
// import CardView from '../pages/Feature/cardView'
import axios from 'axios'
import StarRating from 'vue-star-rating'
import { BaseURL } from '../shared/classes'
import router from '../router/index'
import ProfileModal from './profileDetails'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// const optionsOverrides1 = {
//   durations: {
//     global: 3000
//   },
//   icons: {
//     enabled: false
//   },
//   labels: {
//     success: '',
//     warning: '',
//     alert: ''
//   },
//   position: 'bottom-right'
// }

export default {
  data () {
    return {
      base_urls: BaseURL,
      releventprofiles: [],
      releventprofilesList: [],
      ind: [],
      config: null,
      list: [
        { key: '0', tec: 'html', isSelected: false },
        { key: '1', tec: 'css', isSelected: false },
        { key: '2', tec: 'JS', isSelected: false }
      ],
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      selectedUserList: [],
      selectedUserList1: [],
      postData: null,
      score: '',
      fromdate: '',
      todate: '',
      modalOpen: false,
      postSearch: '',
      statusFilter: '',
      ratingFilter: '',
      interviewerCostFrom: '',
      interviewerCostTo: '',
      costReferTag: '',
      isLoading: false
    }
  },
  components: {
    StarRating,
    ProfileModal,
    Loading

    //  CardView
  },
  created () {
    this.getRelaventProfiles()
    this.getPostDetails()
  },
  methods: {
    showModal (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.$route.params.id))
      localStorage.setItem('_id', this.userInfo._id)
      this.modalOpen = true
    },
    getRelaventProfiles () {
      this.isLoading = true
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      var data = {
        search: this.postSearch,
        status: this.statusFilter,
        rating: this.ratingFilter,
        interviewer_cost_from: this.interviewerCostFrom,
        interviewer_cost_to: this.interviewerCostTo,
        org_emailid: this.userInfo.user_email
      }
      var mainurl =
        '/dashboard/get_relavent_profile_newreq/web/' + this.$route.params.id
      axios
        .post(`${this.base_urls}${mainurl}`,
          {
            formData: data
          },
          this.config)
        .then(response => {
          this.costReferTag = response.data.cost_refer_tag
          this.releventprofiles = response.data.postDetails
          this.releventprofilesList = this.releventprofiles
          this.isLoading = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    clearFilter () {
      this.statusFilter = ''
      this.postSearch = ''
      this.ratingFilter = ''
      this.interviewerCostFrom = ''
      this.interviewerCostTo = ''
      this.getRelaventProfiles()
    },
    uploadResume () {},
    changeInd (index) {
      this.ind[index] = !this.ind[index]
      console.log('this.ind111 - ', this.ind)
    },
    changeInd1 (index) {
      this.ind[index] = false
      console.log('this.ind222 - ', this.ind)
    },
    selectone (force) {
      if (force.selected_interviewer === 'Yes') {
        Vue.set(force, 'selected_interviewer', 'No')
        this.selectedUserList.forEach((value, index) => {
          if (value.user_id === force._id) {
            this.selectedUserList.splice(index, 1)
          }
        })
      } else {
        Vue.set(force, 'selected_interviewer', 'Yes')
        this.selectedUserList.push({ user_id: force._id })
      }
      console.log('this.selectedUserList1 - ', this.selectedUserList)
    },
    selectInterviewers () {
      // router.push({ name: 'CandidateDetails' })
      this.mainurl = '/dashboard/add_selected_interviewers'
      // this.releventprofilesList.forEach((value, index) => {
      //   if (value.selected_interviewer === 'Yes') {
      //     this.selectedUserList.push({ user_id: value._id })
      //   }
      // })
      console.log('this.selectedUserList - ', this.selectedUserList)
      // if (this.selectedUserList.length !== 0) {
      var formData = {
        post_id: this.$route.params.id,
        org_id: this.userInfo._id,
        selected_interviewers: this.selectedUserList
      }
      axios
        .post(
          BaseURL + this.mainurl,
          {
            formData: formData
          },
          this.config
        )
        .then(response => {
          this.$awn.success('Interviewers selected successfully')
          router.push(
            '/candidate_profiles/' + this.$route.params.id + '/all'
          )
        })
        .catch(e => {
          console.log(e)
        })
      // } else {
      //   this.$awn.alert('No datas are selected', optionsOverrides1)
      // }
    },
    getPostDetails () {
      axios
        .get(
          BaseURL + '/dashboard/get_post_details_web/' + this.$route.params.id
        )
        .then(response => {
          this.postData = response.data.postInfo[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    goBack () {
      // router.push('/candidate_profiles/' + this.$route.params.id)
      this.$router.push(
        '/candidate_profiles/' + this.$route.params.id + '/all'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.postArea {
  background: white;
  width: 100%;
  display: flex;
  // justify-content: space-between;
  // align-items: center;
  flex-direction: column;
  padding: 10px;
  //   border: solid 2px #80808030;
  border-radius: 5px;
  row-gap: 10px;
}
.postDetail {
  background: #f1f1f1;
  width: 100%;
  display: flex;
  // justify-content: space-between;
  // align-items: center;
  flex-direction: row;
  padding: 10px;
  //   border: solid 2px #80808030;
  border-radius: 5px;
  row-gap: 10px;
}
.countStyle {
  font-size: 2.5rem !important;
}
.countSpecificationStyle {
  font-size: 1.3rem !important;
}
.candidateArea {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.Orgimage1 {
  border-radius: 50%;
}
.round {
  width: 70px;
  height: 70px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 7px;
}
.candidateDetails {
  // width: 50%;
  text-align: start;
}
.postAreaLi {
  background: #f2f2f2;
  border-radius: 5px;
}
.maincontent {
  display: flex;
  flex-direction: column;
  margin: 10px 4% 4%;
  background-color: white;
  padding: 10px;
  // min-height: 450px;
}
.ratingArea {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}
.round {
  width: 70px;
  height: 70px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 7px;
}
.rating {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.starRating {
  display: flex;
  justify-content: center;
}
.starRatings {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: center;
  gap: 8px;
  padding-right: 15px;
}
.canImage {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 5px;
}
.selectArea {
  margin-bottom: 6px;
}
.isSelected {
  background-color: transparent;
  border: none;
  color: #5bad2b;
}
.centerButton {
  text-align: center;
}

.roundedBorder {
  border-radius: 20px;
  padding: 7px 27px 7px 27px;
  border: none;
}
.fw-600 {
  font-weight: 600;
}
.filterBoxBorder {
  border: 1px solid rgb(237, 234, 234);
  background-color: #f5f5f5;
  padding-bottom: 8px;
  margin-top: 10px;
}
.filterbyClass {
  background-color: #f5f5f5;
}
.filterTopclass {
  list-style: none;
  // margin: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}
.filterListclass {
  padding: 4px 10px 0px 10px;
  // border-bottom: 0.5px solid rgb(249, 248, 248);
}
.mycontent {
  backdrop-filter: #f5f5f5;
}
.backicon {
  color: #5bad2b;
}
.myIcons {
  padding-top: 5px;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  // display: flex;
  // flex-direction: row;
  justify-content: flex-end;
}
div.searchinput input[type="text"] {
  padding: 10px;
  font-size: 14px;
  border: 1px solid rgb(217, 215, 215);
  float: left;
  width: 300px;
  background: white;
  outline: none;
}

div.searchinput button {
  float: left;
  width: 50px;
  padding: 10px;
  background: #5bad2b;
  color: white;
  font-size: 14px;
  border: 1px solid rgb(217, 215, 215);
  border-left: none;
  cursor: pointer;
}

div.searchinput button:hover {
  background: green;
}

div.searchinput::after {
  content: "";
  clear: both;
  display: table;
}
.filterdata {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 10px;
}
.filterBoxBorder {
  border: 1px solid rgb(237, 234, 234);
  background-color: #f5f5f5;
  padding-bottom: 8px;
}
.filterbyClass {
  background-color: #f5f5f5;
}
.btncolorClass {
  color: #5bad2b;
}
a {
  color: #333;
}
.filterDivclass {
  background-color: white;
  padding: 10px;
}
.slider1 {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider1:hover {
  opacity: 1;
}

.slider1::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #5bad2b;
  cursor: pointer;
}

.slider1::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #5bad2b;
  cursor: pointer;
}

.slider2 {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider2:hover {
  opacity: 1;
}

.slider2::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #5bad2b;
  cursor: pointer;
}

.slider2::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #5bad2b;
  cursor: pointer;
}
.canName {
  font-size: 18px;
  font-weight: bold;
}
</style>
